module.exports = __webpack_public_path__ + "img/game3.1.0860d5f0.png";